// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2EWtm","file":"styles_file__TgRMs"};